import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigation"
export default class extends Controller {
	static targets = ["item"]

	connect() {
		this.itemTargets.forEach((item) => {
			if (item.dataset.action) {
				item.dataset.action = item.dataset.action.concat(" ", "click->navigation#selectItem")
			} else {
				item.dataset.action = "click->navigation#selectItem"
			}
		})
	}

	selectItem({ currentTarget }) {
		this.itemTargets.forEach((item) => item.removeAttribute("data-ui"))
		currentTarget.dataset.ui = "aktiv"
	}
}
